import { useTranslation } from "react-i18next";
import type { PresentPerson } from "../../../api/content/reviewCollaborationApi";
import type { MemberNames } from "../../threads/data/useMemberNames";
import PersonAvatar from "../../../ui/avatars/PersonAvatar";

/**
 * Who has this review open (curation-ui.md CU-10): small avatars, each titled with the
 * person's name and the unit they look at. Presence is never stored; it shows only while
 * their page sends heartbeats.
 */
export default function PresenceBar({ present, people, unitName }: { present: readonly PresentPerson[]; people: MemberNames; unitName: (unitKey: string | null) => string }) {
  const { t } = useTranslation();
  const others = present.filter((person) => person.userId !== people.currentUserId);
  if (others.length === 0) {
    return null;
  }
  return (
    <p className="flex items-center gap-1.5 text-xs" aria-label={t("reviews.collaboration.presence.label")}>
      <span className="app-text-muted">{t("reviews.collaboration.presence.here")}</span>
      <span className="flex">
        {others.map((person) => {
          const name = people.nameOf(person.userId);
          const title = t("reviews.collaboration.presence.at", { name, unit: unitName(person.unitKey) });
          return (
            <span key={person.userId} role="img" className="-ml-1 inline-flex first:ml-0" title={title} aria-label={title}>
              <PersonAvatar userId={person.userId} name={name} size="sm" className="app-presence-avatar" />
            </span>
          );
        })}
      </span>
    </p>
  );
}
